import React, { Component } from 'react';
import {
    Typography,
    Box,
    TextField,
    Button,
    withStyles
} from '@material-ui/core';

const styles = theme => ({
    sectionBody: {
        padding: theme.spacing(2),
    },
    respostaContainer: {
        marginTop: theme.spacing(2),
    },
    itensList: {
        marginBottom: theme.spacing(2),
    },
    itemText: {
        fontSize: '0.9rem',
        color: '#666',
        marginBottom: theme.spacing(0.5),
    },
});

class RespondFormSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            textoResposta: '',
            valorTotal: 0,
            itensResposta: []
        };
    }

    componentDidMount() {
        const { respostaInicial } = this.props;
        if (respostaInicial) {
            this.setState(respostaInicial);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.respostaInicial !== this.props.respostaInicial) {
            this.setState(this.props.respostaInicial);
        }
    }

    handleTextoChange = (texto) => {
        this.setState({ textoResposta: texto }, () => {
            this.notifyParent();
        });
    };

    handleValorChange = (valor) => {
        this.setState({ valorTotal: valor }, () => {
            this.notifyParent();
        });
    };

    adicionarItem = (novoItem) => {
        this.setState(prevState => {
            const novoTextoResposta = prevState.textoResposta +
                (prevState.textoResposta ? "\n" : "") + novoItem.texto;

            return {
                textoResposta: novoTextoResposta,
                valorTotal: prevState.valorTotal + novoItem.valor,
                itensResposta: [...prevState.itensResposta, novoItem]
            };
        }, () => {
            this.notifyParent();
        });
    };

    notifyParent = () => {
        this.props.onRespostaChange && this.props.onRespostaChange(this.state);
    };

    handleEnviar = () => {
        const { textoResposta, valorTotal } = this.state;
        this.props.onEnviarResposta && this.props.onEnviarResposta(textoResposta, valorTotal);
    };

    render() {
        const { classes, modo } = this.props;
        const { textoResposta, valorTotal, itensResposta } = this.state;

        return (
            <Box className={classes.sectionBody}>
                {itensResposta.length > 0 && (
                    <Box className={classes.itensList}>
                        <Typography variant="subtitle2" gutterBottom>
                            {this.props.currentLanguage.bepiService.shared.shared_resp_form_items_added}:
                        </Typography>
                        {itensResposta.map((item, index) => (
                            <Typography key={index} className={classes.itemText}>
                                • {item.texto}
                            </Typography>
                        ))}
                    </Box>
                )}

                <Box className={classes.respostaContainer}>
                    <TextField
                        fullWidth
                        multiline
                        rows={4}
                        label={this.props.currentLanguage.bepiService.shared.shared_resp_form_obs_label}
                        value={textoResposta}
                        onChange={(e) => this.handleTextoChange(e.target.value)}
                        placeholder={this.props.currentLanguage.bepiService.shared.shared_resp_form_placeholder}
                        style={{ marginBottom: 16 }}
                    />

                    <TextField
                        fullWidth
                        type="number"
                        label={this.props.currentLanguage.bepiService.workshop.workshop_respond_total_value_label}
                        value={valorTotal}
                        onChange={(e) => this.handleValorChange(parseFloat(e.target.value) || 0)}
                        inputProps={{ step: "0.01" }}
                        style={{ marginBottom: 16 }}
                    />

                    <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleEnviar}
                    >
                        {this.props.currentLanguage.bepiService.workshop.workshop_respond_finish_btn}
                    </Button>
                </Box>
            </Box>
        );
    }
}

export default withStyles(styles)(RespondFormSection);
